// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2ooAE","row":"styles_row__SDh5l"};